var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0ZM35 66.25C17.74 66.25 3.75 52.2588 3.75 35C3.75 17.7388 17.74 3.75 35 3.75C52.26 3.75 66.25 17.7388 66.25 35C66.25 52.2588 52.26 66.25 35 66.25Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.334 68.334C63.8568 68.334 68.334 63.8568 68.334 58.334C68.334 52.8111 63.8568 48.334 58.334 48.334C52.8111 48.334 48.334 52.8111 48.334 58.334C48.334 63.8568 52.8111 68.334 58.334 68.334Z",
    fill: "#898989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.334 65.834C62.4761 65.834 65.834 62.4761 65.834 58.334C65.834 54.1918 62.4761 50.834 58.334 50.834C54.1918 50.834 50.834 54.1918 50.834 58.334C50.834 62.4761 54.1918 65.834 58.334 65.834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.334 63.334C61.0954 63.334 63.334 61.0954 63.334 58.334C63.334 55.5726 61.0954 53.334 58.334 53.334C55.5726 53.334 53.334 55.5726 53.334 58.334C53.334 61.0954 55.5726 63.334 58.334 63.334Z",
    fill: "#898989"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 35C23.75 37.7625 24.8875 40.25 26.7 42.05L23.75 45H31.25V37.5L28.45 40.3C27.1 38.9375 26.25 37.075 26.25 35C26.25 31.7375 28.3375 28.9625 31.25 27.9375V25.325C26.9375 26.4375 23.75 30.3375 23.75 35ZM33.75 41.25H36.25V38.75H33.75V41.25ZM46.25 25H38.75V32.5L41.55 29.7C42.9 31.0625 43.75 32.925 43.75 35C43.75 38.2625 41.6625 41.0375 38.75 42.0625V44.675C43.0625 43.5625 46.25 39.6625 46.25 35C46.25 32.2375 45.1125 29.75 43.3 27.95L46.25 25ZM33.75 36.25H36.25V28.75H33.75V36.25Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncOff);
export default __webpack_public_path__ + "static/media/syncOff.76a2fbf05f78baec469d3dea2c247eed.svg";
export { ForwardRef as ReactComponent };